import OfferBox from "../../components/OfferBox/OfferBox"; 
import styles from './Offer.module.css'; 

export default function Offer() {
    return (
        <main className={styles.offer}>
            <OfferBox
                title="Diagnoza logopedyczna (60 min. - 90 min.)"
                price="200zł"
                description="Diagnoza polega na rozpoznaniu rodzaju i przyczyny trudności językowych, artykulacyjnych,
głosowych czy komunikacyjnych. Proces ten obejmuje:
Wywiad – rozmowę z pacjentem i/lub rodzicami/opiekunami, dotyczącą przebiegu
rozwoju, zdrowia, środowiska rodzinnego, edukacyjnego i społecznego.
Obserwację – analizę zachowań komunikacyjnych, reakcji na pytania, gestów,
kontaktu wzrokowego i sposobów porozumiewania się.
Badanie logopedyczne – ocenę:
artykulacji (wymowy głosek),
słuchu fonematycznego (rozróżnianie dźwięków mowy),
zasobu słownictwa i gramatyki,
rozumienia i budowania wypowiedzi,
płynności mówienia,
głosu (jego barwy, siły, wysokości),
funkcji anatomicznych i motorycznych aparatu mowy (język, wargi,
podniebienie, żuchwa).

Skierowanie na badania specjalistyczne (jeśli są potrzebne) – np. na konsultację
neurologiczną, audiologiczną, laryngologiczną, ortodontyczną, psychologiczną,
fizjoterapeutyczną i inne.

Efektem diagnozy jest określenie rodzaju zaburzenia i ich przyczyn oraz indywidulany
plan terapii."
            />
                     <OfferBox
                title="Terapia logopedyczna (45 min.)"
                price="120zł"
                description="Terapia to systematyczna praca z pacjentem, zawsze dostosowana do jego wieku, rodzaju i
stopnia trudności. Jej celem jest nie tylko usprawnianie mowy, ale również budowanie
pewności siebie i komfortu w komunikacji.
W zależności od potrzeb terapia może obejmować:
Ćwiczenia artykulacyjne – usprawnianie mięśni aparatu mowy i naukę prawidłowej
wymowy głosek.
Ćwiczenia miofunkcjonalne - ich celem jest prawidłowa praca mięśni twarzy, języka,
warg i całego obszaru orofacjalnego, nauka oddychania przez nos, prawidłowe
gryzienie, żucie i połykanie.

Ćwiczenia słuchowe – rozwój percepcji słuchowej i umiejętności różnicowania
dźwięków.
Ćwiczenia oddechowe i głosowe – prawidłowe oddychanie, emisję głosu oraz dbanie
o jego higienę.
Ćwiczenia językowe – wzbogacanie słownictwa, rozwój gramatyki, naukę budowania
zdań i rozumienia tekstów.
Współpracę z rodziną i otoczeniem – wskazówki dla rodziców, nauczycieli i bliskich,
jak wspierać dziecko na co dzień.
Wsparcie emocjonalne i motywacyjne – pomoc w budowaniu poczucia własnej
wartości i relacji społecznych."
            />
                     <OfferBox
                title="Terapia ręki (50 min.)"
                price="120zł"
                description="Diagnoza sprawności motorycznej dziecka. Ćwiczenia gimnastyczne całego ciała,
prowadzące do stabilizacji centralnej i swobodnej pracy rąk, aby były one w stanie realizować
swoje funkcje w możliwie najlepszy sposób."
            />
                     <OfferBox
                title="Terapia pedagogiczna (45 min.)"
                price="100zł"
                description="Terapia dysleksji, trening umiejętności szkolnych, przygotowanie do nauki czytania i pisania,
nauka czytania metodą sylabową, rozwijanie funkcji poznawczych."
            />
                     <OfferBox
                title="Pisemna opinia logopedyczna"
                price="100zł"
                description="Wydawana na prośbę rodzica, opiekuna, osoby zainteresowanej w terminie do 2 tygodni."
            />

        </main>
    );
}